import React, { useState, useEffect } from 'react';
import { UsuariosAdapter } from "../../../../infraestructure/persistence/rest/UsuariosAdapter";
import { useNotifications } from "../../../../shared/hooks/Notifications";
import { ServerErrorMessage } from "../../../../shared/utils/error";
import { HorasUserScreen } from './screen';

export const HorasUserContainer = (props:any) =>{

    const {filtro,user,dateInit}=props;

    const api = new UsuariosAdapter();
	const {resultError, exceptionError, launchNotification}  = useNotifications();
	let [ data, setData ] = useState<any>([]);
	let result: any;

    const getHorasUser = async (filter:any) => {
		const newFilter = filter!==undefined ? filter : {}
		try {
			result = await api.ListarHorasUsuario({...filtro,...newFilter});
			if(result.data && result.data!=="")
			{
				setData([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

    return (
		<>
		<HorasUserScreen
			data={data}
			user={user}
			handleGetData={getHorasUser}
			dateInit={dateInit}
		/>
		</>
	);
}